/**
 * @author Anvesh B
 * @description This Component is used for EAM WOrk Flow
 * @view flowchart and table view for list of workflow in tab view
 */
import React, { useState, useEffect } from 'react';
import { Button, Drawer, Form, Select, message } from 'antd';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import Flowchart from 'flowchart-react';
import { decode as base64_decode } from 'base-64';

import {
  getWorkTypesWF,
  getRoles,
  insertWF,
  updateWF,
  getCommunication,
  getStatusListWF,
  getStatus,
  getWorkFlowById
} from '../../../Utils/FormCalls';
import '../../../CSS/workFlow.css';
import history from '../../../../../commons/history';
import translation from '../../../Utils/translation';
import themeSettings from '../../../Utils/themeSettings.json';
import { getTranslationCache } from '../../../../../selectors/language';
import { constant } from '../../../Utils/constants';
import { StyledComponent } from '../../../CSS/style';
import InputComponent from '../../../Widgets/InputComponent';
import { getUserProfile } from '../../../../../selectors/layout';
import WFHeader from './WFHeader';
const { Option } = Select;

const WorkFlow = (props) => {
  const [form] = Form.useForm();
  const [form1] = Form.useForm();
  // const [form2] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [check, setCheck] = useState(false);
  const [nodeData, setNodeData] = useState({});
  const [nodes, setNodes] = useState([]);
  const [conns, setConns] = useState([]);
  const [connect, setConnect] = useState({});
  const [workTypes, setWorkTypes] = useState([]);
  const [roles, setRoles] = useState([]);
  // const [workFlowList, setWFList] = useState([]);
  const [record, setrecordData] = useState({});
  // eslint-disable-next-line no-unused-vars
  const [orderStatus, setWOStatus] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [communication, setCommunication] = useState([]);
  // const [userProfile, setUserProfile] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  const onClose = () => {
    setVisible(false);
    setCheck(false);
    form1.resetFields();
    form.resetFields();
  };

  useEffect(() => {
    (async () => {
      _getDataById();
      try {
        let worktype = await getWorkTypesWF();
        setWorkTypes(worktype.data);
      } catch (error) {
        message.error(`${error.response.data.message}`);
      }
      try {
        let role = await getRoles();
        setRoles(role.data);
      } catch (error) {
        message.error(`${error.response.data.message}`);
      }
      try {
        let woStatus = await getStatus();
        setWOStatus(woStatus);
      } catch (error) {
        message.error(`${error.response.data.message}`);
      }
      try {
        let communication = await getCommunication();
        setCommunication(communication.data);
      } catch (error) {
        message.error(`${error.response.data.message}`);
      }
      try {
        let statusList = await getStatusListWF();
        setStatusList(statusList.data);
      } catch (error) {
        message.error(`${error.response.data.message}`);
      }
    })();
  }, []);

  useEffect(() => {
    form.resetFields();
    form1.resetFields();
    // form2.resetFields();
  }, [nodeData, connect, record]);

  const _getDataById = async (Id) => {
    let path = history.location.pathname.split('/rubus/AMM/WorkFlowDetails/');
    let formId = base64_decode(path[1]);
    if (formId !== 'new') {
      let record = await getWorkFlowById(base64_decode(path[1]));

      if (record && record.Node) {
        setNodes(record.Node.nodes);
        setConns(record.Node.connections);
      }
      setrecordData(record);
    } else {
      let record = await getWorkFlowById(Id);

      if (record && record.Node) {
        setNodes(record.Node.nodes);
        setConns(record.Node.connections);
      }

      setrecordData(record);
    }
  };

  const handleNode = (node) => {
    setNodeData(node);
    setVisible(true);
  };
  const handleConnection = (connection) => {
    setCheck(true);
    setConnect(connection);
  };
  const onFinishMAin = async (values) => {
    let userId =
      props.userProfile && props.userProfile.user && props.userProfile.user.Id
        ? props.userProfile.user.Id
        : '';
    let payload = {
      ...values,
      ...(values && !values.Id ? { CreatedBy: userId } : {}),
      ...(values && values.Id ? { UpdatedBy: userId } : {}),
      'Min&Sec': values && values['Min&Sec'] ? values['Min&Sec'].format('mm:ss') : '',
      nodesData: { nodes: nodes, connections: conns }
    };
    // try {
    if (record && record.Id) {
      let statusResponse = await updateWF({
        ...payload,
        Id: record && record.Id ? record.Id : undefined
      });
      if (statusResponse && statusResponse.message) {
        // _getDataById(statusResponse.Id);
        message.success(`WorkFlow Updated Successfully`);
      } else if (statusResponse && statusResponse.Error) {
        message.error(statusResponse.Error);
      }
    } else {
      let statusResponse = await insertWF(payload);
      if (statusResponse && statusResponse.message) {
        _getDataById(statusResponse.Id);
        message.success(`WorkFlow Created Successfully`);
      } else if (statusResponse && statusResponse.Error) {
        message.error(statusResponse.Error);
      }
    }
    // }
    //  catch (error) {
    // message.error(`${error.response.data.message}`);
    // }
  };
  const onFinish = (values) => {
    form.resetFields();
    const newState =
      nodes &&
      Array.isArray(nodes) &&
      nodes.map((obj) => {
        if (obj.id === nodeData.id) {
          return {
            ...obj,
            title: values.title,
            role: values.role,
            email: values.email,
            communicationType: values.communicationType
          };
        }
        return obj;
      });
    setNodes(newState);
    setNodeData({});
    setVisible(false);
  };
  const onFinishCon = (values) => {
    form1.resetFields();
    const newState =
      conns &&
      Array.isArray(conns) &&
      conns.map((obj) => {
        if (
          obj.source.id === connect.source.id &&
          obj.source.position === connect.source.position
        ) {
          return { ...obj, type: values.type, status: values.status };
        }
        return obj;
      });
    setConnect({});
    setConns(newState);

    setCheck(false);
  };
  return (
    <>
      <StyledComponent theme={themeSettings} style={{ minHeight: window.innerHeight - 73 }}>
        <Drawer
          className="WorkFlowDrawer"
          style={{ color: 'black' }}
          title={translation(translationCache, constant.nodeData)}
          placement="right"
          onClose={onClose}
          visible={visible}
        >
          <Form form={form} initialValues={nodeData} layout="vertical" onFinish={onFinish}>
            <Form.Item name="id" label={translation(translationCache, constant.Id)}>
              <InputComponent disabled />
            </Form.Item>
            {nodeData && nodeData.type && nodeData.type !== 'start' ? (
              <Form.Item
                name="title"
                label={translation(translationCache, constant.title)}
                rules={[{ required: true, message: 'Please Input your Title!' }]}
              >
                <InputComponent placeholder={translation(translationCache, 'Input Title ')} />
              </Form.Item>
            ) : null}
            {nodeData && nodeData.type && nodeData.type === 'start' ? (
              <Form.Item
                name="title"
                label={translation(translationCache, constant.title)}
                rules={[{ required: true, message: 'Please Input your Title!' }]}
              >
                <Select placeholder={translation(translationCache, 'Select Option ')}>
                  <Option value="Start">{translation(translationCache, constant.start)}</Option>
                  <Option value="End">{translation(translationCache, constant.end)}</Option>
                </Select>
              </Form.Item>
            ) : null}
            <Form.Item
              name="role"
              label={translation(translationCache, constant.role)}
              rules={[{ required: false, message: 'Please Select Role!' }]}
            >
              <Select placeholder={translation(translationCache, 'Select Role')}>
                {roles &&
                  Array.isArray(roles) &&
                  roles.map((param, index) => {
                    return (
                      <Option key={index} value={param.Value}>
                        {' '}
                        {param.Key}{' '}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
            <Form.Item
              name="communicationType"
              label={translation(translationCache, constant.communicationType)}
            >
              <Select
                placeholder={translation(translationCache, constant.selectOption)}
                mode="multiple"
                rules={[{ required: false, message: 'Please Select Role!' }]}
                showArrow={true}
              >
                {communication &&
                  Array.isArray(communication) &&
                  communication.map((type, index) => {
                    return (
                      <Option key={index} value={type.Value}>
                        {translation(translationCache, type.Key)}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                {' '}
                {translation(translationCache, constant.submit)}{' '}
              </Button>
            </Form.Item>
          </Form>
        </Drawer>
        <Drawer
          className="WorkFlowDrawer"
          title={translation(translationCache, constant.connectionData)}
          placement="right"
          onClose={onClose}
          visible={check}
        >
          <Form form={form1} initialValues={connect} layout="vertical" onFinish={onFinishCon}>
            <Form.Item
              name="type"
              label={translation(translationCache, constant.type)}
              rules={[
                { required: true, message: translation(translationCache, 'Please Select Type!') }
              ]}
            >
              <Select placeholder={translation(translationCache, 'Select a option')}>
                <Option value="fail">{translation(translationCache, constant.fail)}</Option>
                <Option value="success">{translation(translationCache, constant.success)}</Option>
              </Select>
            </Form.Item>
            <Form.Item
              name="status"
              label={translation(translationCache, constant.status)}
              rules={[
                { required: true, message: translation(translationCache, 'Please Select status!') }
              ]}
            >
              <Select placeholder={translation(translationCache, 'Select a option')}>
                {' '}
                {statusList &&
                  Array.isArray(statusList) &&
                  statusList.map((param, index) => {
                    return (
                      <Option key={index} value={param.Key}>
                        {translation(translationCache, param.Key)}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                {' '}
                {translation(translationCache, constant.submit)}{' '}
              </Button>
            </Form.Item>
          </Form>
        </Drawer>

        <div>
          <>
            <WFHeader
              themeSettings={themeSettings}
              record={record}
              onFinish={onFinishMAin}
              translationCache={translationCache}
              workTypes={workTypes}
            />
            <Flowchart
              onChange={(nodes, connections) => {
                setNodes(nodes);
                setConns(connections);
              }}
              showToolbar
              onNodeDoubleClick={handleNode}
              onConnectionDoubleClick={handleConnection}
              style={{ width: '100%', height: 500 }}
              nodes={nodes}
              connections={conns}
            />
          </>
        </div>
      </StyledComponent>
    </>
  );
};
const mapStateToProps = createStructuredSelector({
  userProfile: getUserProfile(),
  translationCache: getTranslationCache()
});
export default connect(mapStateToProps)(WorkFlow);
